import { injectable } from "inversify";
import type { ISeoSortingState } from "@studyportals/fawkes/organisations-search-seo";
import { SortingOptions } from "@/sorting/SortingOptions";
import { SortingSelection } from "@/sorting/SortingSelection";

@injectable()
export class SeoSortingSelection implements ISeoSortingState {

	public constructor(
		private sortingState: SortingSelection
	) { }

	public getSelectedOption(): SortingOptions {
		return this.sortingState.getSelected();
	}
}